export default __webpack_public_path__ + "static/media/aws-logo.316da603.png";